import React from "react";
import * as styles from "./DynamicHero.module.css";
import { Cta } from "../../elements/Cta/Cta";
import {
  ComponentProps,
  KontentRichText,
  PageLink,
  Vector,
  YesNo,
} from "../../../types/index";
import { SectionWrapper } from "../../containers/SectionWrapper";
import { CustomRichTextElement } from "../../elements/CustomRichTextElement/CustomRichTextElement";
import {
  MediaHeroProps,
  MediaHeroWrapper,
} from "../../elements/HeroWrapper/Media";
import { Link } from "../../elements/Link/Link";

export type OverlayStyle = "solid" | "gradient" | "gradientLeft";
interface Props extends ComponentProps, MediaHeroProps {
  vector?: Vector;
  title: string;
  text?: KontentRichText;
  sidekick?: KontentRichText;
  cta?: PageLink[];
  hideSidekickOnMobile?: YesNo;
  overlayStyle?: OverlayStyle;
  headingType?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
}

export const MediaDynamicHero: React.FC<Props> = ({
  desktopImage,
  mobileImage,
  videoUrl,
  title,
  text,
  sidekick,
  cta,
  hideSidekickOnMobile,
  style,
  vector,
  height,
  overlayStyle = "gradient",
  headingType = "h1",
  ...props
}) => {
  const HeadingTag = headingType;
  const titleClasses = [styles.title];
  if (!text) {
    titleClasses.push(styles.large);
  }

  return (
    <SectionWrapper {...props}>
      <MediaHeroWrapper
        desktopImage={desktopImage}
        mobileImage={mobileImage}
        videoUrl={videoUrl}
        style={style}
        height={height}
        overlayStyle={overlayStyle}
      >
        <div className={styles.hero}>
          <div className={styles.heroContent}>
            <div className={titleClasses.join(" ")}>
              <HeadingTag data-kontent-element-codename="title">
                {title}
              </HeadingTag>
              {vector?.item?.url && vector?.item?.type === "image/svg+xml" && (
                <div className={styles.accent}>
                  <img src={vector?.item.url} alt={vector?.alt} />
                </div>
              )}
            </div>
            {text && (
              <div data-kontent-element-codename="text" className={styles.text}>
                <CustomRichTextElement content={text} />
              </div>
            )}
            {cta && cta[0]?.href && (
              <div
                className={styles.ctas}
                data-kontent-element-codename="link_configuration__link"
              >
                <div className={styles.primaryCta}>
                  <Cta
                    href={cta[0].href}
                    label={cta[0].label}
                    target={cta[0].target}
                  />
                </div>
                {cta[1] && (
                  <div className={styles.secondaryCta}>
                    <Link to={cta[1].href} target={cta[1].target}>
                      {cta[1].label}
                    </Link>
                  </div>
                )}
              </div>
            )}
          </div>
          {sidekick &&
            (sidekick?.modular_content ||
              sidekick?.value !== "<p><br></p>") && (
              <div
                className={`${styles.sidekickContent} ${
                  hideSidekickOnMobile === "no" ? styles.visible : null
                }`}
              >
                <div data-kontent-element-codename="sidekick">
                  <CustomRichTextElement content={sidekick} />
                </div>
              </div>
            )}
        </div>
      </MediaHeroWrapper>
    </SectionWrapper>
  );
};
